import { render } from "./ResetLogin.vue?vue&type=template&id=18be205c&scoped=true&ts=true"
import script from "./ResetLogin.vue?vue&type=script&lang=ts"
export * from "./ResetLogin.vue?vue&type=script&lang=ts"

import "./ResetLogin.vue?vue&type=style&index=0&id=18be205c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18be205c"]])

export default __exports__